import React from "react"
import { useSiteQuery, useLink } from "../../hooks"

export const useSchema = (
    category,
    data
) => {
    const siteUrl = "https://digitup.in/"

    const { headerLogo } = useSiteQuery()
    switch (category) {
        case 'website':
            return {
                "@context": "http://schema.org",
                "@type": "WebSite",
                "name": "Digitup",
                "url": "https://digitup.in/",
            }
        case "organization":
            return {
                "@context": "https://schema.org",
                "@type": "Organization",
                "url": "https://digitup.in/",
                "logo": headerLogo.file.url.includes('https://') ? headerLogo.file.url : `https:${headerLogo.file.url}`,
                "slogan": 'Power to Evolve',
            }
        case "carousel":
            return {
                "@context": "https://schema.org",
                "@type": "ItemList",
                "itemListElement": data.array.map(({ slug, thumbnailTitle }, index) => {
                    return {
                        "@type": "ListItem",
                        "position": index + 1,
                        "url": `${siteUrl}${useLink(slug)}`,
                        "name": thumbnailTitle
                    }
                })
            }
        case "blog":
            return {
                "@context": "https://schema.org",
                "@type": "NewsArticle",
                "headline": data.title,
                "datePublished": data.datePublished,
                "dateModified": data.dateModified,
                "image": [
                    `https:${data.image}`
                ],
                "author":
                    [
                        {
                            "@type": "Organization",
                            "name": "Digitup",
                            "url": siteUrl
                        }
                    ]
            }
    }
}